import { Microfrontend } from '@cian/mf-react';
import * as React from 'react';

type TMicrofrontendElement = React.ElementRef<typeof Microfrontend>;

/**
 * Монтирует микрофронтенд строго на клиенте: рекламу нельзя рендерить на SSR.
 * `isReady` поднимается в `true` через `setTimeout(…, 0)` уже после гидрации,
 * место под баннер до этого держит плейсхолдер (без CLS).
 */
export function useAdBannerMicrofrontend() {
  const microfrontendRef = React.useRef<TMicrofrontendElement | null>(null);
  const [isReady, setIsReady] = React.useState(false);

  React.useEffect(() => {
    const timer = window.setTimeout(() => setIsReady(true), 0);

    return () => window.clearTimeout(timer);
  }, []);

  return { microfrontendRef, isReady };
}
